import * as React from "react";
import { RouteComponentProps } from "@reach/router";

export const WhatIsLP = (props: WhatIsLpProps) => {
  return <div>What is LP?</div>;
};

type WhatIsLpProps = RouteComponentProps;
